/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const WebhookClusterGwPost = {
  id: 'webhook.cluster-gw.post',
  tag: 'Webhook',
  summary: 'Handle ClusterGW',
  description: 'Handle ClusterGW',
  method: 'post',
  route: () => `/webhook/clustergw`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            status: ZodTypes.ClusterStatus,
            old_status: ZodTypes.ClusterStatus,
            action: ZodTypes.ClusterGWAction,
            payload: z.object({
              workspace_id: z.string(),
              customer_id: z.number().int(),
              cluster_id: z.number().int(),
              replica_status: z.object({
                replicas: z.number().int(),
                readyReplicas: z.number().int().optional(),
                currentReplicas: z.number().int().optional(),
                updatedReplicas: z.number().int().optional(),
              }),
            }),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
